/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  ns.TimeFrameSelectorView = ns.BaseSelectorView.extend({
    name: "TimeFrame Selector",
    el: "#timeframe-selector",
    templateSelector: "#timeframe-selector-template",
    propertyName: "timeFrameId",
    selectorInfoPropertyName: "timeFrames",

    initialize: function(options) {
      _.bindAll(
        this,
        "onChangeUpdateModel",
        "initializeModel",
        "updateDOM",
        "onBeforeChange"
      );

      this.getSelectorInfoFunc = options.getSelectorInfoFunc;

      // Handle the before change event so that we have an opportunity to update the
      // TimeFrameId when the indicator ID changes.
      this.model.on("before-change", this.onBeforeChange);
    },

    events: {
      change: "onChangeUpdateModel"
    },

    onBeforeChange: function(newProps) {
      // If the indicator ID is changing, then we may need to also change the Time Frame ID
      // since each indicator could have a different set of TFs
      if (this.model.get("indicatorId") !== newProps.indicatorId) {
        var allSelectorInfo = this.getSelectorInfoFunc();
        var selectorInfo = allSelectorInfo.selectors[newProps.indicatorId];

        var oldTfId = this.model.get(this.propertyName);

        // If possible, keep the ID the same
        var sameAsOld = _.find(selectorInfo.timeFrames, function(tf) {
          return tf.id == oldTfId;
        });
        if (sameAsOld != null) {
          return;
        }

        // Different set of TFs? Select the first one
        var newTf = selectorInfo.timeFrames[0];

        // Update the newProps object to reflect our change
        newProps[this.propertyName] = "" + newTf.id;
      }
    },

    onChangeUpdateModel: function() {
      this.model.set(this.propertyName, $("select", this.$el).val());

      // Tracks when a user clicks on the "Timeframe" dropdown menu
      var timeFrame = $("select :selected", this.$el).text();
      dataLayer.push({
        event: "Timeframe Dropdown Clicks",
        eventCategory: "Interactive Clicks",
        eventAction: "Timeframe Dropdown|" + timeFrame,
        eventLabel: window.location.pathname
      });
    },

    initializeModel: function() {
      // Update the model with the first item in the dropdown
      this.model.set(this.propertyName, $("select", this.$el).val(), {
        silent: true
      });
    },

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      return $("select option:selected", this.$el).text();
    },

    updateDOM: function() {
      // Set the option corresponding to the value on the model
      $("select", this.$el).val(this.model.get(this.propertyName));
    }
  });
})(jQuery, _);
